import React, { useMemo } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { GlobalTaxForm } from './global-taxform';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxIdHelpPopUpId, LegalIdentifierHintI18nKey, LegalIdentifierNumberPilot, GlobalTaxIdCountryCodeToPilots } from '../constants';
import { registerTaxform } from '../taxform-store';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { addLegalIdentifierNumberInTaxSchema, withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot, getPilotStatus, getTaxTypeLabel } from '../utils';
import { EmptyTaxForm } from './empty-taxform';
import { CustomValidateItems } from '../validator';
import { CNTaxViewTaxForm } from './viewtaxforms/china-viewtaxform';

const {
  CountryCode, TaxType, TaxCNVatNumberRegExp, TaxLabelFormat,
} = Constants;
const { regexTest } = StringUtils;
const taxIdValidator = _.partial(regexTest, TaxCNVatNumberRegExp);

const taxSchemaGetter = ({ permissions }) => {
  const IsLegalIdentifierNumberPilotOn = getPilotStatus(LegalIdentifierNumberPilot, permissions);
  const taxSchema = {
    name: 'China Taxation Validation Schema',
    type: 'object',
    properties: {
      [TaxType.VatNumber]: {
        type: 'string',
        required: false,
        helpPopupTopic: GlobalTaxIdHelpPopUpId,
      },
    },
  };
  if (IsLegalIdentifierNumberPilotOn) {
    addLegalIdentifierNumberInTaxSchema(taxSchema);
  }
  return taxSchema;
};

const ChinaTaxForm = ({
  i18n,
  data,
  mtData,
  onValidate,
  showLineByLineFormGroup,
  alwaysShowError,
  taxCertification,
  mtTaxCertification,
  urlBuilder,
  disabled,
  permissions,
}) => {
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(CustomValidateItems.ChinaVATFormatValidation), [i18n]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.CN }), [i18n]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      urlBuilder={urlBuilder}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      showTaxCert={false}
      permissions={permissions}
      showLegalIdentifierNumberField
      legalIdentifierHint={i18n.getString(LegalIdentifierHintI18nKey[CountryCode.CN])}
    />
  );
};

ChinaTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = GlobalTaxIdCountryCodeToPilots.CN;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: ChinaTaxForm, DefaultForm: EmptyTaxForm });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: CNTaxViewTaxForm, DefaultForm: EmptyViewTaxForm });

// Hide tax form in Hong Kong (91)
const pathRegex = /^\/CN\/(?!91($|\/)).*/;
export const matcher = ({ path }) => pathRegex.test(path.toUpperCase());

registerTaxform('/CN/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }), matcher);
